import { render, staticRenderFns } from "./relatorios.vue?vue&type=template&id=1d273af3"
import script from "./relatorios.vue?vue&type=script&lang=js"
export * from "./relatorios.vue?vue&type=script&lang=js"
import style0 from "./relatorios.vue?vue&type=style&index=0&id=1d273af3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports